module.exports = __webpack_public_path__ + "static/media/deleteNoti.9e921a78.svg";